import React, { Component } from "react";
import "./Home.css";
import {  ListGroup ,ListGroupItem ,ButtonGroup ,Button,Jumbotron,FormGroup,ControlLabel,FormControl} from "react-bootstrap";
import { API } from "aws-amplify";
import Moment from 'react-moment';
import AUTHMD from '../md/HomeAuthenticated.md'
import UNAUTHMD from '../md/HomeUnAuthenticated.md'
import LoaderButton from "../components/LoaderButton";
import ReactMarkdown from 'react-markdown/with-html'

function guid() {
  function s4() {
    return Math.floor((1 + Math.random()) * 0x10000)
      .toString(16)
      .substring(1);
  }
  return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
}



export default class Admin extends Component {
    constructor(props) {
      super(props);
      this.state = {
          myaltioms:[],
          myaltioms_fetching:true,
          markdown:"",
          newUser:false,
          responce:"",
          isLoading:true,
          isSuper:false,
      };
    }

    async componentWillMount() {
      const data = await this.getInfo();
      console.log(data)
      if (data.data.super==true){
        this.setState({isSuper:true})
      }else{

      }
      this.setState({isLoading:false})
      console.log(this.state)
    }
    responceChanged=(e)=>{
      console.log(e.target.value)
      this.setState({responce:e.target.value})

    }

    getInfo() {
      return API.get("AltiomData", "/welcome");
    }
    render() {
      return (
          <div className="Home">
          <Jumbotron>

            {this.state.isSuper ? (
            <div>
            <h2>Admin</h2>
            <hr/>
            <h2><a href="/AllAltioms">View Altioms</a></h2>
            <h2><a href="/admin/users">Manage users</a></h2>
            <h2><a href="/admin/branch">Manage branches</a></h2>
            <h2><a href="/admin/codes">Permission codes</a></h2>
            </div>):(
              <div>
                {this.state.isLoading ? (<p>Checking....</p>):(<p>You are not an admin!</p>)}



              </div>
            )}



{/*
            <h3>Groups<small> Groups altioms together all altioms in a particular location/site</small></h3>

            <Button>Get List</Button>

            <h4>Create new group:</h4>
            <input placeholder="Name of Group"></input>
            <span>UID</span><input placeholder="UID" value={guid()}></input>
            Temperature Mode<input type="checkbox"></input>
            <Button>Add</Button>
            <hr/>

*/}











            </Jumbotron>
          </div>
        );
    }
}

//{this.props.isAuthenticated ? <ReactMarkdown className="CenterText" source={this.state.md_auth}  escapeHtml={false} /> : <ReactMarkdown className="CenterText" source={this.state.md_unauth}  escapeHtml={false}/>}



// WEBPACK FOOTER //
// ./src/containers/Admin.js